export class RecordsAreaItem {
  areaid: string;
  description: string;
  level: string;
  constructor(rawRecordAreaItem: any) {
    this.areaid = rawRecordAreaItem.AreaId;
    this.description = rawRecordAreaItem.Description;
    this.level = rawRecordAreaItem.Level;
  }
}
